import { AUTH_ROLES } from '@core/authentication/auth.roles';
import { OiqLayoutNavItemModel } from '@oiq-layout/nav/nav-item.models';
import { V2_REPORTS_ACCESS_ROLES } from '@v2/v2-routing.guards';

export const APP_MENU_ADMIN_ROLES = [AUTH_ROLES.SUPER_ADMIN];

export const APP_MENU_TENANT_ROLES = [AUTH_ROLES.SUPER_ADMIN];

export const APP_MENU_HOME_ROLES = [
  AUTH_ROLES.ADMIN,
  AUTH_ROLES.ONYXIQ_ADMIN,
  AUTH_ROLES.WHITE_LABEL_ADMIN,
  AUTH_ROLES.FULL,
  AUTH_ROLES.UNDERWRITING,
  AUTH_ROLES.OPERATIONS,
  AUTH_ROLES.PRE_UNDERWRITING,
  AUTH_ROLES.ISO,
  AUTH_ROLES.COLLECTIONS,
  AUTH_ROLES.ACCOUNTING,
  AUTH_ROLES.ISO_MANAGER,
  AUTH_ROLES.MANAGER_OF_ISO_MANAGERS,
  AUTH_ROLES.SYNDICATOR,
  AUTH_ROLES.MASTER_SYNDICATOR,
  AUTH_ROLES.MANAGER,
];

export const APP_MENU_BORROWING_BASE_ROLES = [
  AUTH_ROLES.ADMIN,
  AUTH_ROLES.ONYXIQ_ADMIN,
  AUTH_ROLES.WHITE_LABEL_ADMIN,
  AUTH_ROLES.FULL,
  AUTH_ROLES.COLLECTIONS,
  AUTH_ROLES.UNDERWRITING,
  AUTH_ROLES.OPERATIONS,
  AUTH_ROLES.PRE_UNDERWRITING,
];

export const APP_MENU_CLIENT_ROLES = [
  AUTH_ROLES.ADMIN,
  AUTH_ROLES.ONYXIQ_ADMIN,
  AUTH_ROLES.WHITE_LABEL_ADMIN,
  AUTH_ROLES.FULL,
  AUTH_ROLES.COLLECTIONS,
  AUTH_ROLES.UNDERWRITING,
  AUTH_ROLES.OPERATIONS,
  AUTH_ROLES.PRE_UNDERWRITING,
  AUTH_ROLES.MANAGER,
];

export const APP_MENU_APPLICATION_ROLES = [
  AUTH_ROLES.ADMIN,
  AUTH_ROLES.ONYXIQ_ADMIN,
  AUTH_ROLES.WHITE_LABEL_ADMIN,
  AUTH_ROLES.FULL,
  AUTH_ROLES.UNDERWRITING,
  AUTH_ROLES.OPERATIONS,
  AUTH_ROLES.PRE_UNDERWRITING,
  AUTH_ROLES.ACCOUNTING,
  AUTH_ROLES.ISO_MANAGER,
  AUTH_ROLES.MANAGER_OF_ISO_MANAGERS,
  AUTH_ROLES.MANAGER,
];

export const APP_MENU_APPLICATION_NEW_ROLES = [
  AUTH_ROLES.ADMIN,
  AUTH_ROLES.ONYXIQ_ADMIN,
  AUTH_ROLES.WHITE_LABEL_ADMIN,
  AUTH_ROLES.OPERATIONS,
  AUTH_ROLES.PRE_UNDERWRITING,
  AUTH_ROLES.MANAGER,
];

export const APP_MENU_FUNDING_ROLES = [
  AUTH_ROLES.ADMIN,
  AUTH_ROLES.ONYXIQ_ADMIN,
  AUTH_ROLES.WHITE_LABEL_ADMIN,
  AUTH_ROLES.FULL,
  AUTH_ROLES.UNDERWRITING,
  AUTH_ROLES.OPERATIONS,
  AUTH_ROLES.PRE_UNDERWRITING,
  AUTH_ROLES.COLLECTIONS,
  AUTH_ROLES.ACCOUNTING,
  AUTH_ROLES.ISO_MANAGER,
  AUTH_ROLES.MANAGER_OF_ISO_MANAGERS,
  AUTH_ROLES.MANAGER,
];

export const APP_MENU_SYNDICATOR_ROLES = [
  AUTH_ROLES.ADMIN,
  AUTH_ROLES.ONYXIQ_ADMIN,
  AUTH_ROLES.WHITE_LABEL_ADMIN,
  AUTH_ROLES.FULL,
  AUTH_ROLES.MANAGER,
];

export const APP_MENU_ISO_ROLES = [
  AUTH_ROLES.ADMIN,
  AUTH_ROLES.ONYXIQ_ADMIN,
  AUTH_ROLES.WHITE_LABEL_ADMIN,
  AUTH_ROLES.FULL,
  AUTH_ROLES.OPERATIONS,
  AUTH_ROLES.PRE_UNDERWRITING,
  AUTH_ROLES.MANAGER,
  AUTH_ROLES.ISO_MANAGER,
  AUTH_ROLES.MANAGER_OF_ISO_MANAGERS,
];

export const APP_MENU_LAW_FIRM_ROLES = [
  AUTH_ROLES.ADMIN,
  AUTH_ROLES.ONYXIQ_ADMIN,
  AUTH_ROLES.WHITE_LABEL_ADMIN,
  AUTH_ROLES.FULL,
  AUTH_ROLES.MANAGER,
];

export const APP_MENU_INSPECTION_COMPANY_ROLES = [
  AUTH_ROLES.ADMIN,
  AUTH_ROLES.ONYXIQ_ADMIN,
  AUTH_ROLES.WHITE_LABEL_ADMIN,
  AUTH_ROLES.FULL,
  AUTH_ROLES.MANAGER,
];

export const APP_MENU_REPORTS_ROLES = [...V2_REPORTS_ACCESS_ROLES];

export const APP_MENU_2WAY_ROLES = [
  AUTH_ROLES.ADMIN,
  AUTH_ROLES.ONYXIQ_ADMIN,
  AUTH_ROLES.WHITE_LABEL_ADMIN,
  AUTH_ROLES.OPERATIONS,
  AUTH_ROLES.PRE_UNDERWRITING,
  AUTH_ROLES.MANAGER,
];

export const APP_MENU_SCORECARD_ROLES = [AUTH_ROLES.ADMIN, AUTH_ROLES.ONYXIQ_ADMIN];
export const APP_MENU_WORKFLOW_ROLES = [AUTH_ROLES.ADMIN, AUTH_ROLES.ONYXIQ_ADMIN];

export const APP_MENU_SETTINGS_ROLES = [
  AUTH_ROLES.SUPER_ADMIN,
  AUTH_ROLES.ADMIN,
  AUTH_ROLES.ONYXIQ_ADMIN,
  AUTH_ROLES.WHITE_LABEL_ADMIN,
];

export const appMenu = (
  roles: string[],
  opts: {
    userRole: string;
    borrowingBase: boolean;
    scorecards: boolean;
    workflows: boolean;
    emailApp: boolean;
    /** General reports visibility based on roles and resource access. */
    reports?: boolean;
    /** Tenant feature `DynamicReports`. Off sends the Reports nav to V1. */
    dynamicReports?: boolean;
    constructionDraws: boolean;
  }
): OiqLayoutNavItemModel[] => {
  const _hasRole = (_roles: string[]): boolean => roles.some(r => _roles.includes(r));
  return [
    // ...homeMenu(roles, opts),
    {
      type: 'route',
      route: '/admin',
      icon: 'assets/icons/home.svg',
      text: 'Home',
      visible: _hasRole(APP_MENU_ADMIN_ROLES),
    },
    {
      type: 'route',
      route: '/admin/tenants',
      icon: 'assets/icons/isos.svg',
      text: 'Tenants',
      visible: _hasRole(APP_MENU_TENANT_ROLES),
    },
    {
      type: 'route',
      icon: 'assets/icons/home.svg',
      text: 'Home',
      routeAlias: ['/home', '/v2/home', '/syndicator/'],
      visible: _hasRole(APP_MENU_HOME_ROLES),
      route: '/v2/home',
    },
    {
      type: 'route',
      route: '/borrowing-base',
      icon: 'assets/icons/borrowing-base.svg',
      text: 'Borrowing Base',
      visible: opts.borrowingBase && _hasRole(APP_MENU_BORROWING_BASE_ROLES),
    },
    {
      type: 'route',
      route: '/v2/clients/list',
      routeAlias: '/v2/clients',
      icon: 'assets/icons/clients.svg',
      text: 'Clients',
      visible: _hasRole(APP_MENU_CLIENT_ROLES),
    },
    {
      icon: 'assets/icons/application.svg',
      text: 'Application',
      routeAlias: ['/applications', '/v2/applications/add'],
      visible: _hasRole(APP_MENU_APPLICATION_ROLES),
      children: [
        // {
        //   type: 'route',
        //   route: '/applications',
        //   materialIcon: 'list',
        //   text: 'Applications',
        //   visible: true,
        // },
        {
          type: 'route',
          route: '/v2/applications',
          materialIcon: 'list',
          text: 'Applications',
          visible: true,
        },
        {
          type: 'route',
          route: '/v2/applications/add',
          materialIcon: 'add',
          text: 'New Application',
          visible: _hasRole(APP_MENU_APPLICATION_NEW_ROLES),
          withSeparator: true,
        },
      ],
    },
    {
      type: 'route',
      route: '/fundings',
      icon: 'assets/icons/fundings.svg',
      text: 'Fundings',
      visible: _hasRole(APP_MENU_FUNDING_ROLES),
    },
    {
      type: 'route',
      route: '/syndicators',
      routeAlias: ['/syndicators'],
      icon: 'assets/icons/syndicators.svg',
      text: 'Syndicators',
      visible: _hasRole(APP_MENU_SYNDICATOR_ROLES),
    },
    {
      type: 'route',
      route: '/v2/syndicators/list/all',
      routeAlias: ['/v2/syndicators'],
      icon: 'assets/icons/syndicators.svg',
      text: 'Syndicators (V2)',
      visible: _hasRole(APP_MENU_SYNDICATOR_ROLES),
    },
    {
      type: 'route',
      route: '/v2/isos/list',
      routeAlias: '/v2/isos',
      icon: 'assets/icons/isos.svg',
      text: 'ISOs',
      visible: _hasRole(APP_MENU_ISO_ROLES),
    },
    {
      type: 'route',
      route: '/v2/law-firms/list',
      icon: 'assets/icons/law-firms.svg',
      text: 'Law Firms',
      visible: _hasRole(APP_MENU_LAW_FIRM_ROLES),
    },
    {
      type: 'route',
      route: '/v2/inspection-companies/list',
      icon: 'assets/icons/inspection-companies.svg',
      text: 'Inspection Companies',
      visible: opts.constructionDraws && _hasRole(APP_MENU_INSPECTION_COMPANY_ROLES),
    },
    {
      type: 'route',
      route: opts.dynamicReports ? '/v2/reports' : '/reports',
      routeAlias: ['/reports', '/v2/reports'],
      icon: 'assets/icons/reports.svg',
      text: 'Reports',
      visible: opts.reports ?? _hasRole(APP_MENU_REPORTS_ROLES),
    },
    {
      type: 'route',
      route: '/v2/email-app',
      queryParams: { label: 'inbox' },
      routeAlias: '/v2/email-app',
      icon: 'assets/icons/email-v2.svg',
      text: 'Email',
      visible: opts.emailApp && _hasRole(APP_MENU_2WAY_ROLES),
    },
    {
      type: 'route',
      route: '/v2/scorecard',
      routeAlias: '/v2/scorecard',
      icon: 'assets/icons/scorecard.svg',
      text: 'Scorecard',
      visible: opts.scorecards && _hasRole(APP_MENU_SCORECARD_ROLES),
    },
    {
      type: 'route',
      route: '/v2/workflow/dashboard',
      routeAlias: '/v2/workflow',
      icon: 'assets/icons/workflow.svg',
      text: 'Workflow',
      visible: opts.workflows && _hasRole(APP_MENU_WORKFLOW_ROLES),
    },
  ];
};

export const appSettingsMenu = (
  roles: string[],
  opts: {
    borrowingBase: boolean;
    scorecards: boolean;
  }
): OiqLayoutNavItemModel => {
  const _hasRole = (_roles: string[]): boolean => roles.some(r => _roles.includes(r));
  const isSuperAdmin = _hasRole([AUTH_ROLES.SUPER_ADMIN]);
  const hasSetting = _hasRole(APP_MENU_SETTINGS_ROLES);
  return {
    type: 'route',
    route: isSuperAdmin ? '/admin/settings' : '/settings',
    icon: 'assets/icons/settings.svg',
    text: 'Settings',
    visible: hasSetting,
  };
};
